export default defineNuxtRouteMiddleware((to) => {
  if (process.server) return

  const token = localStorage.getItem('token')
  const layout = to.meta.layout

  if (layout === 'dashboard' && !token) {
    return navigateTo('/login')
  }
})
